import { useAppDispatch, useAppSelector } from "@app/store";
import { useUserId } from "@hooks/use-user-id";
import { useCallback } from "react";
import { AppealForm, CreateAppealRequest, MerchantAppealForm, UpdateAppealApiRequest } from "./api";
import {
  createAppeal,
  getAppeals,
  getAppealsByOrderId,
  getMerchantAppeals,
  updateAppeal,
  uploadReceipt,
} from "./slice";

export const useAppeals = () => {
  const userId = useUserId();
  const state = useAppSelector((state) => state.appeal);
  const dispatch = useAppDispatch();

  const getAppealsHandler = useCallback(
    (data: AppealForm) => dispatch(getAppeals({ userId, data })),
    [dispatch, userId]
  );

  const getMerchantAppealsHandler = useCallback(
    (data: MerchantAppealForm) => dispatch(getMerchantAppeals({ userId, data })),
    [dispatch, userId]
  );

  const getAppealsByOrderIdHandler = useCallback(
    (orderId: string) => dispatch(getAppealsByOrderId({ orderId })), // TODO
    [dispatch]
  );

  const uploadReceiptHandler = useCallback(
    (appealId: string, file: FileList) =>
      dispatch(uploadReceipt({ appealId, file })),
    [dispatch]
  );

  const createAppealHandler = useCallback(
    (data: CreateAppealRequest) => dispatch(createAppeal({ data })),
    [dispatch]
  );

  const updateAppealHandler = useCallback(
    (appealId: string, data: UpdateAppealApiRequest) =>
      dispatch(updateAppeal({ appealId, data })),
    [dispatch]
  );

  return {
    state,
    getAppeals: getAppealsHandler,
    getAppealsByOrderId: getAppealsByOrderIdHandler,
    uploadReceipt: uploadReceiptHandler,
    createAppeal: createAppealHandler,
    getMerchantAppeals: getMerchantAppealsHandler,
    updateAppeal: updateAppealHandler,
  };
};
